import React, { useState } from "react";
import Header from "../../../sharedScreens/Header";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "../../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import MuiButton from "../../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import { FormControlLabel, Radio } from "@mui/material";
import UserListFilter from "../../../components/composite/UserListFilter";
import useCompanyList from "../../../services/customHooks/useCompanyList";
import { branchList, statusList } from "../../../constants/constant";

const FareView = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const CMFilterPopUp = () => {
    const [selectedBranch, setSelectedBranch] = useState<string>("");
    const {
      data: corporateList,
      loading,
      error,
    } = useCompanyList(selectedBranch || {});

    const [selectedCorporate, setSelectedCorporate] = useState("");
    const [selectedCorporateId, setSelectedCorporateId] = useState("");
    const [status, setStatus] = useState("");
    const handleBranchChange = (value: string, id: any) => {
      setSelectedBranch(value);
      setSelectedCorporate("");
    };

    const handleCorporateChange = (value: string, id: any) => {
      setSelectedCorporate(value);
      setSelectedCorporateId(id);
    };
    const handleStatus = (value: string) => {
      setStatus(value);
    };
    const handleSubmit = () => {
      setOpen(false);
    };

    const handleClear = () => {
      setSelectedBranch("");
      setSelectedCorporate("");
      setStatus("");
    };
    return (
      <>
        <div className="">
          <form>
            <div className="row  align-items-center">
              <div className="col-md-6">
                <label className="form-label">
                  From Date <span className="text-danger">*</span>
                </label>
                <MuiDatePicker
                  value={null}
                  onChange={function (date: string): void {
                    throw new Error("Function not implemented.");
                  }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">To Date</label>
                <MuiDatePicker
                  value={null}
                  onChange={function (date: string): void {
                    throw new Error("Function not implemented.");
                  }}
                />
              </div>

              <div className="row">
                <div className="checkbox-container d-flex gap-3 flex-wrap align-items-center p-4">
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="all-checkbox"
                    />
                    <label htmlFor="all-checkbox">All</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="monday-checkbox"
                    />
                    <label htmlFor="monday-checkbox">Monday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="tuesday-checkbox"
                    />
                    <label htmlFor="tuesday-checkbox">Tuesday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="wednesday-checkbox"
                    />
                    <label htmlFor="wednesday-checkbox d-flex align-items-center gap-2">Wednesday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="thursday-checkbox"
                    />
                    <label htmlFor="thursday-checkbox ">Thursday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="friday-checkbox"
                    />
                    <label htmlFor="friday-checkbox">Friday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="saturday-checkbox"
                    />
                    <label htmlFor="saturday-checkbox">Saturday</label>
                  </div>
                  <div className="checkbox-item d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="sunday-checkbox"
                    />
                    <label htmlFor="sunday-checkbox">Sunday</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="user-button w-full">
              <MuiButton
                className="get-btn"
                label="Apply All"
                type="submit"
                onClick={handleSubmit}
              />
              <MuiButton
                className="clear-btn"
                label="Cancel"
                type="submit"
                onClick={handleClear}
              />
            </div>
          </form>
        </div>
      </>
    );
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Fare View/Update</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Flight No"
                          placeholder="Flight No"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Sector"
                          placeholder="Sector"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDatePicker
                          label="Effective From "
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="Effective To "
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label="Title"
                          placeholder="Enter Title"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Booking Type"
                          placeholder="Booking Type"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Supplier"
                          placeholder="Supplier"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3 mt-3">
                        <MuiInput
                          label="Airline PNR"
                          placeholder="Enter Airline PNR"
                        />
                      </div>
                      <div className="col-md-3 mt-3">
                        <h5>Filter</h5>
                        <FormControlLabel
                          value="All"
                          control={<Radio />}
                          label="All"
                        />

                        <FormControlLabel
                          value="Valid"
                          control={<Radio />}
                          label="Valid"
                        />
                        <FormControlLabel
                          value="Expired"
                          control={<Radio />}
                          label="Expired"
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Submit"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                     <div className="col-md-3 mb-2">
                     <button onClick={handleOpen} className="fliter-btn">
                        <span>Smart Calculator</span>
                      </button>
                     </div>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th style={{ width: 50 }}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </th>
                              <th>Date</th>
                              <th>Seat</th>
                              <th
                                colSpan={5}
                                className="t-class-header text-center"
                              >
                                T Class
                              </th>
                              <th>Others</th>
                              <th>Delete</th>
                            </tr>
                            <tr>
                              <th />
                              <th />
                              <th />
                              <th>Seat</th>
                              <th>Markup</th>
                              <th>Adult</th>
                              <th>Child</th>
                              <th>Infant</th>
                              <th />
                              <th />
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="fareview">
                              <td className="align-middle text-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </td>
                              <td className="align-middle">Sun,01 Dec 24</td>
                              <td className="align-middle">10/10</td>
                              <td className="align-middle">
                                <div className="seat-value purple-bg">
                                  10/10
                                </div>
                              </td>
                              <td className="align-middle text-center">10</td>
                              <td className="align-middle text-center">510</td>
                              <td className="align-middle text-center">110</td>
                              <td className="align-middle text-center">100</td>
                              <td className="align-middle text-center">
                                <button className="others-btn">Others</button>
                              </td>
                              <td className="align-middle text-center">
                                <button className="delete-btn">Delete</button>
                              </td>
                            </tr>
                            <tr className="fareview">
                              <td className="align-middle text-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </td>
                              <td className="align-middle">Mon,02 Dec 24</td>
                              <td className="align-middle">10/10</td>
                              <td className="align-middle">
                                <div className="seat-value purple-bg">
                                  10/10
                                </div>
                              </td>
                              <td className="align-middle text-center">10</td>
                              <td className="align-middle text-center">510</td>
                              <td className="align-middle text-center">110</td>
                              <td className="align-middle text-center">100</td>
                              <td className="align-middle text-center">
                                <button className="others-btn">Others</button>
                              </td>
                              <td className="align-middle text-center">
                                <button className="delete-btn">Delete</button>
                              </td>
                            </tr>
                            <tr className="fareview">
                              <td className="align-middle text-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </td>
                              <td className="align-middle">Tue,03 Dec 24</td>
                              <td className="align-middle">10/10</td>
                              <td className="align-middle">
                                <div className="seat-value purple-bg">
                                  10/10
                                </div>
                              </td>
                              <td className="align-middle text-center">10</td>
                              <td className="align-middle text-center">510</td>
                              <td className="align-middle text-center">110</td>
                              <td className="align-middle text-center">100</td>
                              <td className="align-middle text-center">
                                <button className="others-btn">Others</button>
                              </td>
                              <td className="align-middle text-center">
                                <button className="delete-btn">Delete</button>
                              </td>
                            </tr>
                            <tr className="fareview">
                              <td className="align-middle text-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </td>
                              <td className="align-middle">Wed,04 Dec 24</td>
                              <td className="align-middle">10/10</td>
                              <td className="align-middle">
                                <div className="seat-value purple-bg">
                                  10/10
                                </div>
                              </td>
                              <td className="align-middle text-center">10</td>
                              <td className="align-middle text-center">510</td>
                              <td className="align-middle text-center">110</td>
                              <td className="align-middle text-center">100</td>
                              <td className="align-middle text-center">
                                <button className="others-btn">Others</button>
                              </td>
                              <td className="align-middle text-center">
                                <button className="delete-btn">Delete</button>
                              </td>
                            </tr>
                            <tr className="fareview">
                              <td className="align-middle text-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                />
                              </td>
                              <td className="align-middle">Thu,05 Dec 24</td>
                              <td className="align-middle">10/10</td>
                              <td className="align-middle">
                                <div className="seat-value purple-bg">
                                  10/10
                                </div>
                              </td>
                              <td className="align-middle text-center">10</td>
                              <td className="align-middle text-center">510</td>
                              <td className="align-middle text-center">110</td>
                              <td className="align-middle text-center">100</td>
                              <td className="align-middle text-center">
                                <button className="others-btn">Others</button>
                              </td>
                              <td className="align-middle text-center">
                                <button className="delete-btn">Delete</button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            label={"Update"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/*-----------------pop code----------------------------  */}
        <UserListFilter
          header={"Smart Calculator"}
          children={<CMFilterPopUp />}
          isVisible={open}
          handleClose={() => handleClose()}
        />
      </div>
    </div>
  );
};

export default FareView;
